// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"6814": "7b4b06288bd0d70e","7173": "4b5cec2fa1116444",}[chunkId] + ".chunk.js"
}